import { Fragment, type HTMLAttributes, type ReactElement } from 'react';
import type { IncidentListItem } from '@/app/services/incident/incident.service';
import { IncidentOmpSnapshotRow } from '@/app/components/incident-overview/IncidentOmpSnapshotRow';

export function createIncidentTableBodyRow(
  incidents: IncidentListItem[],
  colSpan: number,
  expandedRowKeys: readonly string[],
) {
  return function IncidentTableBodyRow(
    props: HTMLAttributes<HTMLTableRowElement> & { 'data-row-key'?: string },
  ): ReactElement {
    const rowKey = props['data-row-key'];
    const record =
      typeof rowKey === 'string'
        ? incidents.find((incident) => incident.id === rowKey)
        : undefined;

    const isExpanded =
      typeof rowKey === 'string' && expandedRowKeys.includes(rowKey);
    const hasSnapshot = Boolean(record?.omp);
    const mainClassName = [
      props.className,
      'incident-overview-main-row',
      hasSnapshot || isExpanded ? '' : 'incident-group-end',
    ]
      .filter(Boolean)
      .join(' ');

    const snapshotClassName = [
      'incident-omp-snapshot-tr',
      hasSnapshot && !isExpanded ? 'incident-group-end' : '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <Fragment>
        <tr {...props} className={mainClassName} />
        {hasSnapshot && record ? (
          <tr className={snapshotClassName}>
            <td colSpan={colSpan} className="incident-omp-snapshot-td">
              <IncidentOmpSnapshotRow incident={record} />
            </td>
          </tr>
        ) : null}
      </Fragment>
    );
  };
}
